import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { CARD_BORDER, SECTION_BACK } from '../colors';

type Props = {
  title: string;
  /** The line under the heading. Only the source-choice section has one. */
  subtitle?: string;
  children: React.ReactNode;
};

/**
 * One bordered section of Zadání kurzu — the shape the design gives all four
 * of them, rather than the bold heading over flat content we had.
 */
export function SectionCard({ title, subtitle, children }: Props) {
  return (
    <Box
      sx={{
        backgroundColor: SECTION_BACK,
        border: `1px solid ${CARD_BORDER}`,
        borderRadius: '8px',
        padding: '18px 20px 20px',
        marginBottom: '20px',
      }}
    >
      <Typography
        sx={{ fontWeight: 700, fontSize: '16px', color: 'var(--color-black)' }}
      >
        {title}
      </Typography>

      {subtitle && (
        <Typography
          sx={{
            fontSize: '14px',
            color: 'var(--color-black-text)',
            marginTop: '6px',
          }}
        >
          {subtitle}
        </Typography>
      )}

      <Box sx={{ marginTop: '14px' }}>{children}</Box>
    </Box>
  );
}
